import { internalGet, internalPut } from './';

export const getOrganizationCountry = (organizationId, countryId) => {
  if (!organizationId || !countryId) {
    return Promise.resolve(null);
  }
  return internalGet(`/organizations/${organizationId}/countries/${countryId}`);
};

export const updateOrganizationCountry = (
  organizationId,
  countryId,
  emails,
) => {
  return internalPut(
    `/organizations/${organizationId}/countries/${countryId}`,
    {
      bookingReceptionEmails: emails,
    },
  );
};
